import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  SxProps,
} from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface IControlledRadioButtons {
  title: string;
  titleSx?: SxProps;
  radioColor?: string;
  isDirectionRow: boolean;
  radioGroupSx?: SxProps;
  values: string[];
  valueSx?: SxProps;
  onChange: Function;
}

export const ControlledRadioButtons = ({
  title,
  titleSx,
  isDirectionRow = true,
  radioColor,
  radioGroupSx,
  values,
  valueSx,
  onChange,
}: IControlledRadioButtons) => {
  const isDesktop = useIsDesktop();

  return (
    <FormControl component='fieldset'>
      <FormLabel
        sx={{
          mb: isDesktop ? '18px' : '14px',
          color: 'inherit',
          fontWeight: 700,
          fontSize: isDesktop ? '20px' : '18px',
          lineHeight: '24px',
          textAlign: 'center',
          fontFamily: 'inherit',
          ...titleSx,
        }}
      >
        {title}
      </FormLabel>
      <FormLabel component='legend'>{title}</FormLabel>
      <RadioGroup
        defaultValue={values[0]}
        row={isDirectionRow}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event.target.value)
        }
        sx={{
          gap: '20px',
          ...radioGroupSx,
        }}
      >
        {values.map((value: string, index: number) => {
          return (
            <FormControlLabel
              key={index}
              value={value}
              control={
                <Radio
                  sx={{
                    padding: 0,
                    margin: 0,
                    color: radioColor || '#A020FF',
                    '&.Mui-checked': {
                      color: radioColor || '#A020FF',
                    },
                    '& label': {
                      margin: 0,
                    },
                  }}
                />
              }
              label={value}
              sx={{
                gap: '7px',
                '& .muirtl-1497ugp-MuiTypography-root': {
                  fontWeight: 600,
                  fontSize: isDesktop ? '18px' : '16px',
                  lineHeight: '24px',
                  fontFamily: 'inherit',
                },
                ...valueSx,
              }}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};
